const API_HOST_US = process.env.NEXT_PUBLIC_LOGIN_HOST || 'https://api-a.ecoflow.com';
const API_HOST_CN = process.env.NEXT_PUBLIC_LOGIN_HOST_CN || 'https://api-cn.ecoflow.com';
const API_HOST_EU = process.env.NEXT_PUBLIC_LOGIN_HOST_EU || 'https://api-e.ecoflow.com';
const data_center_eu = ['de', 'it', 'uk', 'fr', 'cis', 'es', 'eu', 'za', 'sa', 'jp', 'kr', 'nl']; //欧州数据中心
const data_center_cn = ['cn']; //国区数据中心
export const getBaseUrl2 = (locale = 'us') => {
    if (data_center_eu.includes(locale)) {
        return API_HOST_EU;
    } else if (data_center_cn.includes(locale)) {
        return API_HOST_CN;
    }
    return API_HOST_US;
};
